import { applicationSlice }         from 'Redux/Slices/Application/ApplicationSlice';
import { userSlice }                from 'Redux/Slices/User/UserSlice';
import { organizerSlice }           from 'Redux/Slices/Organizer/OrganizerSlice';
import { eventCategorySlice }       from 'Redux/Slices/EventCategory/EventCategorySlice';
import { eventParentCategorySlice } from 'Redux/Slices/EventParentCategory/EventParentCategorySlice';
import { eventSlice }               from 'Redux/Slices/Event/EventSlice';
import { locationSlice }            from 'Redux/Slices/Location/LocationSlice';
import { eventTicketSlice }         from 'Redux/Slices/EventTicket/EventTicketSlice';
import { settingsSlice }            from 'Redux/Slices/Settings/SettingsSlice';
import { invoiceSlice }             from 'Redux/Slices/Invoice/InvoiceSlice';
import { userTicketSlice }          from 'Redux/Slices/UserTicket/UserTicketSlice';
import { salesSlice }               from 'Redux/Slices/Sales/SalesSlice';
import { appUserSlice }             from 'Redux/Slices/AppUser/AppUserSlice';
import { organisationInvoiceSlice } from 'Redux/Slices/OrganisationInvoice/OrganisationInvoiceSlice';
import { employeeSlice }            from 'Redux/Slices/Employee/EmployeeSlice';

const Actions = {
  ...applicationSlice.actions,
  ...userSlice.actions,
  ...organizerSlice.actions,
  ...eventParentCategorySlice.actions,
  ...eventCategorySlice.actions,
  ...eventSlice.actions,
  ...locationSlice.actions,
  ...eventTicketSlice.actions,
  ...settingsSlice.actions,
  ...invoiceSlice.actions,
  ...userTicketSlice.actions,
  ...salesSlice.actions,
  ...appUserSlice.actions,
  ...organisationInvoiceSlice.actions,
  ...employeeSlice.actions,
};

export type TActions = typeof Actions;

const failureActionKeys = Object.keys(Actions).filter((actionType: string) => !!actionType.match(/Failure/));

export const FailureActions = {};
failureActionKeys.forEach((actionType: string) => {
  // @ts-ignore
  FailureActions[actionType] = Actions[actionType];
});

export const errorActionConstants = Object.values(FailureActions).map((action: any) => action.type);

export default Actions;
